// CRM does not yet expose participant document bytes to the video training UI.
// Flip to true when the backend + CRM integration can serve downloads/opens.
export const DOCUMENTS_DOWNLOAD_ENABLED = false;

export const DOCUMENTS_COMING_SOON_MESSAGE =
  "Document download isn't available yet. This feature is coming soon.";
